import React, { useState, useRef } from "react";
import audioFile from "../sample.mp3";

const AudioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(audioFile));

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (

    <div
    onClick={togglePlayPause}
    style={{
      marginLeft: "30px",
      marginTop: "20px",
      cursor: "pointer",
      width: "50px",
      height: "50px",
      backgroundColor: "black",
      display: "flex",          
      justifyContent: "center", 
      alignItems: "center"     
    }}
  >
    {isPlaying ? (
      <img src="/assets/icons/Pause.svg" alt="pause icon"/>
    ) : (
      <img src="/assets/icons/Play.svg" alt="play icon"/>
    )}
  </div>
  
  
  );
};

export default AudioPlayer;
